import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 1239A338-77EE-47E5-A50B-2BC667AD7BB1
 * name arrow-left-top-bold
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-top-bold.svg
 * tags
 */
export const ArrowLeftTopBoldIcon = createSvgIcon(<><path d="M21 21H17V13.5C17 11.57 15.43 10 13.5 10H11V14L4 8L11 2V6H13.5C17.64 6 21 9.36 21 13.5V21Z" /></>, 'ArrowLeftTopBoldIcon');
export default ArrowLeftTopBoldIcon